export const MULTICALL3_ADDRESS = '0xcA11bde05977b3631167028862bE2a173976CA11' as const;

export const multicall3Abi = [
  { type: 'function', name: 'getBasefee', stateMutability: 'view', inputs: [], outputs: [{ name: 'basefee', type: 'uint256' }] },
  { type: 'function', name: 'getEthBalance', stateMutability: 'view', inputs: [{ name: 'addr', type: 'address' }], outputs: [{ name: 'balance', type: 'uint256' }] },
  { type: 'function', name: 'getBlockNumber', stateMutability: 'view', inputs: [], outputs: [{ name: 'blockNumber', type: 'uint256' }] },
] as const;
